import { useState } from 'react';
import { site } from '@/mocks/manhwa';

const faqs = [
  {
    q: '好看的韩漫推荐网站主要推荐什么类型的作品？',
    a: '本站收录的韩漫推荐涵盖都市日常、奇幻冒险、恋爱、热血战斗、悬疑惊悚、穿越重生和治愈暖萌等多种题材，既有人气高分大作，也有冷门宝藏，按题材分类整理，方便你快速找到合口味的作品。',
  },
  {
    q: '高分人气榜是怎么排出来的？',
    a: '高分人气榜综合了作品的读者评分与讨论热度，优先展示口碑与热度双在线的必看韩漫。榜单会随评分变化动态更新，帮助新人快速入坑。',
  },
  {
    q: '冷门宝藏栏目里的作品质量可靠吗？',
    a: '冷门宝藏栏目的作品由编辑人工筛选，特点是口碑好但相对冷门，适合已经看过不少韩漫、想挖宝换口味的老读者。每部都经过试读与评估，值得收藏。',
  },
  {
    q: '我可以推荐自己喜欢的韩漫上榜吗？',
    a: '当然可以。你可以在下方表单提交你喜欢的韩漫，包括作品名、作者、题材与推荐理由。编辑审核后会择优收录进书单。',
  },
  {
    q: '作品详情页能看到什么内容？',
    a: '每部韩漫的详情页都会展示作品简介、作者、题材标签、评分与连载状态，并给出同题材的相关推荐，方便你顺藤摸瓜找到更多佳作。',
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('company_alt')?.toString().trim() ?? '';
    if (honeypot !== '') {
      setStatus('success');
      form.reset();
      return;
    }
    setStatus('loading');
    setFormError('');
    const payload: Record<string, string> = {};
    formData.forEach((value, key) => {
      if (key !== 'company_alt' && typeof value === 'string') payload[key] = value;
    });
    try {
      const res = await fetch('https://readdy.ai/api/form/da2lrird3r93mn1k3bn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
      const isSpam = serverMsg.toLowerCase().includes('spam');
      const ok = res.ok && parsed?.code === 'OK' && !isSpam;
      if (ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试。');
    }
  }

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-question-line" /> 常见问题
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于韩漫书单，你可能想问</h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              整理了读者最常问的问题。如果还有疑惑，欢迎通过表单或邮件与我们交流。
            </p>

            <div className="mt-8 space-y-3">
              {faqs.map((f, i) => (
                <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                  <button
                    type="button"
                    aria-expanded={openIdx === i}
                    onClick={() => setOpenIdx(openIdx === i ? null : i)}
                    className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950">{f.q}</span>
                    <i
                      className={`${openIdx === i ? 'ri-subtract-line' : 'ri-add-line'} shrink-0 text-foreground-500`}
                    />
                  </button>
                  {openIdx === i && (
                    <p className="border-t border-background-100 px-4 py-3.5 text-sm leading-6 text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div id="contact" className="scroll-mt-24">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-foreground-950">推荐你的漫画</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                有心水的韩漫想进书单？把作品信息告诉我们，编辑会择优收录。
              </p>

              {status === 'success' ? (
                <div className="mt-6 rounded-xl bg-secondary-100 p-6 text-center">
                  <i className="ri-checkbox-circle-fill text-3xl text-secondary-600" />
                  <p className="mt-2 text-sm font-medium text-secondary-900">感谢推荐！我们会尽快审核收录。</p>
                  <button
                    type="button"
                    onClick={() => setStatus('idle')}
                    className="mt-4 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2 text-sm text-background-50 hover:bg-secondary-600"
                  >
                    再推荐一部
                  </button>
                </div>
              ) : (
                <form data-readdy-form="recommend-manhwa" onSubmit={handleSubmit} className="mt-6 space-y-4">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label htmlFor="title" className="mb-1.5 block text-sm text-foreground-700">作品名</label>
                      <input
                        id="title"
                        name="title"
                        required
                        placeholder="例如：全知读者视角"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      />
                    </div>
                    <div>
                      <label htmlFor="author" className="mb-1.5 block text-sm text-foreground-700">作者</label>
                      <input
                        id="author"
                        name="author"
                        placeholder="作者名或原作"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label htmlFor="category" className="mb-1.5 block text-sm text-foreground-700">题材分类</label>
                      <select
                        id="category"
                        name="category"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      >
                        <option value="">请选择题材</option>
                        <option value="都市日常">都市日常</option>
                        <option value="奇幻冒险">奇幻冒险</option>
                        <option value="恋爱漫">恋爱漫</option>
                        <option value="热血战斗">热血战斗</option>
                        <option value="悬疑惊悚">悬疑惊悚</option>
                        <option value="穿越重生">穿越重生</option>
                        <option value="治愈暖萌">治愈暖萌</option>
                      </select>
                    </div>
                    <div>
                      <label htmlFor="email" className="mb-1.5 block text-sm text-foreground-700">联系邮箱</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="you@example.com"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="reason" className="mb-1.5 block text-sm text-foreground-700">推荐理由</label>
                    <textarea
                      id="reason"
                      name="reason"
                      maxLength={500}
                      rows={4}
                      placeholder="说说这部韩漫为什么好看，最多 500 字"
                      className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                    />
                    <p className="mt-1 text-right text-xs text-foreground-500">最长 500 字</p>
                  </div>

                  <input
                    type="text"
                    name="company_alt"
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    tabIndex={-1}
                    className="hp-field"
                  />

                  {status === 'error' && (
                    <p className="rounded-lg bg-primary-100 px-4 py-3 text-sm text-primary-800">
                      <i className="ri-error-warning-line mr-1" /> {formError}
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'loading'}
                    className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 sm:w-auto"
                  >
                    {status === 'loading' ? '提交中…' : '提交推荐'}
                    <i className="ri-send-plane-line" />
                  </button>
                </form>
              )}
              <p className="mt-4 text-xs text-foreground-500">
                也可以直接邮件联系我们：<a href={`mailto:${site.email}`} className="text-primary-600 hover:underline">{site.email}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}